import API from "../Api";

export const apiSac = (dni) => API.post(`/api/v1/sac`, dni);
export const apiSacSensitive = (formValues) => API.post(`/api/v1/sac/sensitive`, formValues);

